var MENU_ICON_VARIANT;
(function (MENU_ICON_VARIANT) {
    MENU_ICON_VARIANT["HAMBURGUER"] = "hamburguer";
    MENU_ICON_VARIANT["KEBAB"] = "kebab";
    MENU_ICON_VARIANT["MEATBALL"] = "meatball";
})(MENU_ICON_VARIANT || (MENU_ICON_VARIANT = {}));
var MENU_ICON_SIZE;
(function (MENU_ICON_SIZE) {
    MENU_ICON_SIZE["LARGE"] = "large";
    MENU_ICON_SIZE["SMALL"] = "small";
    MENU_ICON_SIZE["FIT"] = "fit";
})(MENU_ICON_SIZE || (MENU_ICON_SIZE = {}));

export { MENU_ICON_VARIANT as M, MENU_ICON_SIZE as a };
